/** Demo participant shown when staff opens «Профиль» from admin panel. */
export const STAFF_PREVIEW_PARTICIPANT = {
  idPervye: 9000001,
  email: 's***1@pb26.test',
  fullName: 'Тестовый Участник (демо)',
} as const;

export const STAFF_PREVIEW_LICENSE = {
  login: '1179_DEMO',
  password: 'demo-preview',
} as const;
